export const PERIODO_AMORTIZACION = {
  MENSUAL: 2,
  ANUAL: 3,
} as const

export type PeriodoAmortizacionType =
  (typeof PERIODO_AMORTIZACION)[keyof typeof PERIODO_AMORTIZACION]
